<template>
  <form-label
    :label="label"
    :class-name="formLabelClassName"
  >
    <template #body>
      <div
        v-for="(item, i) in items"
        :key="i"
      >
        <label class="pega-input display-inline">
          <input
            v-model="item.isChecked"
            type="checkbox"
          ><span class="pega-break">{{ item.label }}</span>
        </label>
        <button
          v-if="item.isShowTrash"
          :disabled="item.isChecked"
          class="boss-icon-trash"
          @click="$emit('delete', item.id)"
        />
      </div>
      <slot name="footer" />
    </template>
  </form-label>
</template>

<style scoped>
input {
  cursor: pointer;
}
</style>

<script>
import FormLabel from '@/components/atoms/FormLabel'

export default {
  components: {
    FormLabel
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    formLabelClassName: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>
